var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicySecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 522,
    viewBox: "0 0 522 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.257 261V143.971H156.771V385.343H293.914M209.8 180.543H308.543M293.914 207.971H224.429M197 239.057H308.543M197 268.314H262.5M266.486 297.571H197M266.486 297.571V350.6C266.486 366.691 303.057 390.219 321.343 399.971C365.229 383.88 377.419 360.352 378.029 350.6V268.314C363.4 268.314 334.143 259.781 321.343 255.514C311.103 259.903 287.5 266 266.486 268.314V297.571ZM197 326.829H250.029M250.029 357.914H197M297.571 317.686L321.343 339.629L361.571 297.571M517 261C517 402.385 402.385 517 261 517C119.615 517 5 402.385 5 261C5 119.615 119.615 5 261 5C402.385 5 517 119.615 517 261Z",
    stroke: "#4487C5",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicySecurity);
export default __webpack_public_path__ + "static/media/policy-security.3a502752b514fe4a58cf034e82a14ebe.svg";
export { ForwardRef as ReactComponent };